import {
  useQuery,
  useInfiniteQuery,
  infiniteQueryOptions,
} from '@tanstack/react-query'
import type {
  UserGetRecentlyVisitedProjectsParams,
  UserListProjectsParams,
} from '../api'
import {
  getProjectCertDetailsOptions,
  getProjectDetailsOptions,
  getRecentlyVisitedProjectsOptions,
  getListProjectsOptionsPre,
} from './user-project.options'
import projectService from './user-project.service'
import { EProjectQueryKey } from './user-project.types'

export const useListProjects = (params: UserListProjectsParams) => {
  return useInfiniteQuery({
    queryKey: [EProjectQueryKey.PROJECT, params],
    queryFn: ({ pageParam = 0 }) => {
      return projectService.getListProjects({
        ...params,
        skip: pageParam * (params.limit || 10),
      })
    },
    getNextPageParam: (lastPage, allPages) => {
      const total = lastPage.data?.total || 0
      const currentLength = allPages.reduce(
        (acc, page) => acc + (page.data?.projects?.length || 0),
        0,
      )
      return currentLength < total ? allPages.length : undefined
    },
    initialPageParam: 0,
  })
}

export const usePrefetchListProjects = (params: UserListProjectsParams) => {
  return useInfiniteQuery(
    infiniteQueryOptions(getListProjectsOptionsPre(params)),
  )
}

export const useGetProjectDetails = (token?: string) => {
  return useQuery(getProjectDetailsOptions(token))
}

export const useGetRecentlyVisitedProjects = (
  params: UserGetRecentlyVisitedProjectsParams,
) => {
  return useQuery(getRecentlyVisitedProjectsOptions(params))
}

export const useGetProjectCertDetails = (token?: string, enabled?: boolean) => {
  return useQuery(getProjectCertDetailsOptions(token, enabled))
}
